// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"CreateEditEquipmentSchedule_titleContainer__1Tfqg","assignButton":"CreateEditEquipmentSchedule_assignButton__20IXi"};